import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2FileOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M8 28V4h8v8h8v14h2V10.086L17.914 2H6v28h18.6l1.4-2zM18 4.914 23.086 10H18zM18.24 22l-1.155 2H10v-2zM22 19H10v-2h12z" /></svg>
);
